import { useModals } from '@/hooks/ModalManager';
import { useDeleteAutomationStep } from '@/screens/Tickets/hooks/useDeleteAutomationStep';
import { useReorderStep } from '@/screens/Tickets/hooks/useUpdateAutomationStep';
import { CustomIcons } from '@/screens/Tickets/utils/customIcons';
import { MenuItem } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useStepActionsMenu } from '.';
import { useCreateStepForm } from '../../../Forms/CreateStep';

function EditStep() {
  const { t } = useTranslation();
  const openForm = useCreateStepForm();
  const { step } = useStepActionsMenu();

  return (
    <MenuItem
      onClick={() => openForm({ stepId: step.id })}
      icon={<CustomIcons.ConfigIcon mx="1" fontSize="lg" />}
    >
      {t('tickets_module.configure_step')}
    </MenuItem>
  );
}

function AddTask() {
  const { t } = useTranslation();
  return (
    <MenuItem
      icon={<CustomIcons.AddIcon fontSize="2xl" />}
      onClick={() => null}
    >
      {t('tickets_module.add_task')}
    </MenuItem>
  );
}

function AddStep() {
  const openForm = useCreateStepForm();
  const { step } = useStepActionsMenu();
  const { t } = useTranslation();

  return (
    <MenuItem
      icon={<CustomIcons.AddIcon fontSize="2xl" />}
      onClick={() =>
        openForm({
          position: step.position ? step.position + 1 : undefined,
        })
      }
    >
      {t('actions.add_step_right')}
    </MenuItem>
  );
}

function MoveStepLeft() {
  const { t } = useTranslation();
  const { step } = useStepActionsMenu();
  const { reorder } = useReorderStep();
  return (
    <MenuItem
      icon={<CustomIcons.GoBackIcon fontSize="2xl" />}
      onClick={() => {
        reorder({ id: step.id, nextPosition: (step.position || 1) - 1 });
      }}
    >
      {t('tickets_module.move_step_left')}
    </MenuItem>
  );
}

function MoveStepRight() {
  const { t } = useTranslation();
  const { step } = useStepActionsMenu();
  const { reorder } = useReorderStep();
  return (
    <MenuItem
      icon={<CustomIcons.RightIcon fontSize="2xl" />}
      onClick={() => {
        reorder({ id: step.id, nextPosition: (step.position || 1) + 1 });
      }}
    >
      {t('tickets_module.move_step_right')}
    </MenuItem>
  );
}

function DeleteStep() {
  const { step } = useStepActionsMenu();
  const { t } = useTranslation();
  const modals = useModals();
  const { deleteAutomationStep } = useDeleteAutomationStep();
  return (
    <MenuItem
      icon={<CustomIcons.TrashIcon fontSize="lg" />}
      onClick={() => {
        modals.confirm({
          title: t('error.warning'),
          body: t('messageDelete.ask'),
          onConfirm() {
            deleteAutomationStep(step.id);
          },
        });
      }}
    >
      {t('tickets_module.delete_step')}
    </MenuItem>
  );
}

export const ActionsOption = {
  EditStep,
  AddStep,
  MoveStepLeft,
  MoveStepRight,
  DeleteStep,
};
